const config = {
    API_BASE_URL: process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:8000/api',
  };
  
  export default config;